import { Component, OnInit } from '@angular/core';
import { AllCallsComponent } from '../../../calls/allCalls.component';
import { PatientService } from '../../../services/patients/patient.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FilterService } from '../../../services/calls/filter.service';
import { ProviderService } from '../../../services/providers/provider.service';
import { Patient } from '../../../classes/patient';
import { Location } from '@angular/common';
import { DoctorService } from '../../../services/doctors/doctor.service';
import { CallService } from '../../../services/calls/call.service';
import { SpecialtiesService } from '../../../services/specialties/specialties.service';
import { AppConfig } from '../../../app.config';
import { Auth } from '../../../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'call-detail',
  templateUrl: './patient-call-detail.component.html',
  styleUrls: [ '../../../users/users.component.css' ]
})
export class PatientCallDetailComponent  extends AllCallsComponent implements OnInit {

  loadingInfo:boolean=true
  patient:Patient;
  info:any[];
  fromDate:Date;
  toDate:Date
  callStates = [];
  searchStatus;

  constructor(protected patientService: PatientService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    protected filterService:FilterService,
    protected providerService:ProviderService,
    protected specialtiesService:SpecialtiesService,
    protected doctorsService: DoctorService,
    protected callService:CallService,
    protected config: AppConfig,
    protected auth: Auth) {
      super(patientService,location,router,filterService,providerService,specialtiesService,doctorsService,callService,config,auth);
    }

  ngOnInit() {
    this.route.params
    .switchMap((params: Params) => this.patientService.getOne(params['id'])
    )
    .subscribe((patient) => {

      this.patient = patient;
      let today = new Date();
      let d = today.getDate().toString();
      let m = (today.getMonth()+1).toString(); //January is 0!
      let y = today.getFullYear().toString();
      let dateTo=''
      let dateFrom=''

      if (d.length == 1) d='0'+d;
      if (m.length == 1) m='0'+m;
      dateTo+=d+'-'+m+'-'+y
      dateFrom+='01'+'-'+m+'-'+y

      this.id=this.patient.id
      this.getInfo(dateFrom,dateTo,this.id,'patient');


    });
    this.callService.getStates().then( states => {
      for (const key in states) {
        this.callStates.push(states[key])
      }
    });
   }

   filter() {
    if (this.fromDate == undefined || this.toDate == undefined) {
      this.alertDate = true;
      return;
    }
    this.alertDate = false;
    this.loadingInfo = true;
    this.from = this.getDate(this.fromDate)
    this.to = this.getDate(this.toDate)
    this.timesSkipped = 0;
    this.currentPage = 0
    this.filterService.save(this.from, this.to, this.provider)
    this.getInfo(this.from, this.to, this.id,'patient')
  }

  nextPage() {
    if (this.currentPage == (this.pages - 1)) {
      if (this.haveCalls) {
        this.getInfo(this.from, this.to, this.id, 'patient');
      }
      else
        return;
    }
    this.currentPage++;
    this.changePage();
  }

}



// WEBPACK FOOTER //
// ./src/app/patients/detail/patient-call-detail/patient-call-detail.component.ts